var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('wzvz_overview_all_hdr',{ref:"wzvz_overview_all_hdr",staticClass:"mb-2",attrs:{"filter":_vm.filter},on:{"updateView":_vm.updateView,"updateSearch":_vm.updateSearch}}),_c('wzvz_overview_all_lst',{ref:"wzvz_overview_all_lst",on:{"updateSelection":_vm.updateSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }